import { readAuthorSetupIdentity } from '../auth/authorSetup';
export async function authorStorageHeaders() {
  const identity = await readAuthorSetupIdentity();
  return { 'Content-Type': 'application/json', Authorization: 'Bearer ' + identity.token };
}
